import { Injectable } from "@angular/core";
import { AuthenticationService, BaseApiService, EnvironmentConfig } from "../../core/core";
import { HttpClient } from "@angular/common/http";
import { AuditLogEntry } from "../models/audit-log-entry.model";

declare var environment: EnvironmentConfig;

@Injectable({ providedIn: "root" })
export class AuditLogService extends BaseApiService<AuditLogEntry> {
  constructor(httpClient: HttpClient, authenticationService: AuthenticationService) {
    super(httpClient, environment.adminApiDomain, "/api/admin/v1/auditlog", true, authenticationService);
  }
}
